import type { Song } from "../types";

/** Frère Jacques / Martinillo (traditional, public domain). */
export const frereJacques: Song = {
  id: "frere-jacques",
  title: "Frère Jacques",
  bpm: 110,
  instrument: "piano",
  notes: [
    { key: "C4", beats: 1 },
    { key: "D4", beats: 1 },
    { key: "E4", beats: 1 },
    { key: "C4", beats: 1 },
    { key: "C4", beats: 1 },
    { key: "D4", beats: 1 },
    { key: "E4", beats: 1 },
    { key: "C4", beats: 1 },
    { key: "E4", beats: 1 },
    { key: "F4", beats: 1 },
    { key: "G4", beats: 2 },
    { key: "E4", beats: 1 },
    { key: "F4", beats: 1 },
    { key: "G4", beats: 2 },
    { key: "G4", beats: 0.5 },
    { key: "A4", beats: 0.5 },
    { key: "G4", beats: 0.5 },
    { key: "F4", beats: 0.5 },
    { key: "E4", beats: 1 },
    { key: "C4", beats: 1 },
    { key: "G4", beats: 0.5 },
    { key: "A4", beats: 0.5 },
    { key: "G4", beats: 0.5 },
    { key: "F4", beats: 0.5 },
    { key: "E4", beats: 1 },
    { key: "C4", beats: 1 },
    { key: "C4", beats: 1 },
    { key: "G4", beats: 1 },
    { key: "C4", beats: 2 },
    { key: "C4", beats: 1 },
    { key: "G4", beats: 1 },
    { key: "C4", beats: 2 },
  ],
};
